export default {
  full_time: '全職',
  part_time: '兼職(含打工)',
  intern: '實習',
  temporary: '臨時工',
  contract: '約聘雇',
  dispatched_labor: '派遣',
};
